export const ALERT_CONSTANTS = {

    ERROR_MODE: 'ERROR_MODE',
    WARNING_MODE: 'WARNING_MODE',
    SUCCESS_MODE: 'SUCCESS_MODE',
}